// @ts-ignore
import wfIcon from '../../../images/wf-icon.svg';
// @ts-ignore
import wfIconMultiple from '../../../images/wf-icon-multiple.svg';
import wfIconPopoverTemplate from './wf-icon-popover.html';

/**
 * @class
 * @description
 * Display the SVG workflow icon
 */
export default class WfIconController {
	/* @ngInject */
	/**
	 * @param {import('angular').ICompileService} $compile
	 * @param {import('angular').ILocationService} $location
	 * @param {import('angular').IScope} $scope
	 * @param {import('angular').ITemplateCacheService} $templateCache
	 */
	constructor(
		$compile,
		$location,
		$scope,
		$templateCache,
	) {
		this.$compile = $compile;
		this.$location = $location;
		this.$scope = $scope;
		this.$templateCache = $templateCache;

		this.viewBox = wfIcon.viewBox;

		/** @type {import('@knitiv/api-client-javascript').Workflow[]} */
		this.wf = [];

		/** @type {import('@knitiv/api-client-javascript').Workflow[]} */
		this.wfs = [];

		if (!document.querySelector('#wf-icon_single')) {
			const div = document.createElement('div');
			div.style.display = 'none';
			div.innerHTML = `<svg viewBox="${wfIcon.viewBox}">${wfIcon.node.innerHTML}</svg>`;
			document.body.insertBefore(div, document.body.childNodes[0]);
		}

		if (!document.querySelector('#wf-icon-multiple_multiple')) {
			const div = document.createElement('div');
			div.style.display = 'none';
			div.innerHTML = `<svg viewBox="${wfIconMultiple.viewBox}">${wfIconMultiple.node.innerHTML}</svg>`;
			document.body.insertBefore(div, document.body.childNodes[0]);
		}
	}

	$onInit() {
		this.$scope.$watch('$ctrl.wf', () => {
			this.wfs = [...this.wf.reduce((/** @type {any} */ accumulator, item) => {
				const key = item.status_kid === 'K_NODE;WFS_CLOSING' ? 'closing' : 'other';
				accumulator[key].push(item);
				return accumulator;
			}, { other: [], closing: [] })
				// Limite à 2 éléments par groupe
				.other
				.slice(0, 2), ...this.wf.filter(item => item.status_kid === 'K_NODE;WFS_CLOSING').slice(0, 2)];
		}, true);
		this.$templateCache.put('wf-icon-popover.html', wfIconPopoverTemplate);
	}
}
